import SmsProvider from './SmsProvider';

export default SmsProvider;
